import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const updateContactApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}v1/${STAGE}/dashboard/contact/${payload._id}`,
      payload.data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
